"use strict";
const GIF = require("./gif");
module.exports = GIF;
